import React from 'react';
import './NotFound.css';

import { Button, PageTitle } from '../../../components';
import { images } from '../../../constants';



const NotFound = () => { 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Not Found'} page={'Not Found'} />

      <section className="error">
        <div className="box-container">

            <img src={images.NotFound} alt='Not Found Imagge' /> 
            <h2>Sorry! Unable to find page</h2>
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum quae eius delectus fugiat sint.</p>
            {/* Button to navigate back to the homepage */}
            <Button link={''} title={'Go Back Home'} />

        </div>
      </section>
    </> 
  );
}

export default NotFound;